import { getDataAPI, postDataAPI, putDataAPI, deleteDataAPI } from './fetchData';

export const listNotesApi = async ({ q, category, bookmarked } = {}) => {
  const token = localStorage.getItem('dizeeToken');
  const params = new URLSearchParams();
  if (q) params.append('q', q);
  if (category) params.append('category', category);
  if (bookmarked !== undefined) params.append('bookmarked', String(!!bookmarked));
  const res = await getDataAPI(`user/notes?${params.toString()}`, token);
  return res.data?.data?.notes || [];
};

export const getNoteApi = async (id) => {
  const token = localStorage.getItem('dizeeToken');
  const res = await getDataAPI(`user/notes/${id}`, token);
  return res.data?.data?.note || null;
};

export const createNoteApi = async ({ title, content, categories } = {}) => {
  const token = localStorage.getItem('dizeeToken');
  const res = await postDataAPI('user/notes', { title, content, categories }, token);
  return res.data?.data?.note;
};

export const updateNoteApi = async (id, { title, content, categories, bookmarked } = {}) => {
  const token = localStorage.getItem('dizeeToken');
  const res = await putDataAPI(`user/notes/${id}`, { title, content, categories, bookmarked }, token);
  return res.data?.data?.note;
};

export const deleteNoteApi = async (id) => {
  const token = localStorage.getItem('dizeeToken');
  const res = await deleteDataAPI(`user/notes/${id}`, token);
  return res.status === 200;
};

export const markViewedApi = async (id) => {
  const token = localStorage.getItem('dizeeToken');
  await postDataAPI(`user/notes/${id}/viewed`, {}, token);
  return true;
};


